import { useMutation, useQueryClient } from '@tanstack/react-query'

import { graphql_call as graphql_admin_call } from '../../schemas/server_admin_query.ts'
import { clear_fund_caches } from '../helpers/fund_cache_helpers.ts'

import { mutation_create_fund_deposit_transaction } from './fund_graphql.ts'

export type CreateFundDepositTransactionInput = {
  feeder_id: string
  amount: number
  user_wallet_address: string
  action_external_tx: string
  action_external_type: 'wire_transfer' | 'ach' | 'sepa' | 'cash'
  executed_at?: string
}

export type CreateFundDepositTransactionResponse = {
  fund_transaction: {
    id: string
    date: string
    action: string
    dollars: number
    action_external_tx: string
    action_external_type: string
    user_wallet_address: string
    feeder_id: string
    fund_id: string
  }
  errors: string[]
}

export function useCreateFundDepositTransaction() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (
      input: CreateFundDepositTransactionInput,
    ): Promise<CreateFundDepositTransactionResponse> => {
      const response = await graphql_admin_call({
        query: mutation_create_fund_deposit_transaction,
        variables: input,
      })
      return response as CreateFundDepositTransactionResponse
    },
    onSuccess: async (data) => {
      if (data.errors.length > 0) {
        return
      }

      await clear_fund_caches({
        queryClient,
        fundId: data.fund_transaction.fund_id,
      })
    },
  })
}
